<script>

import axios from 'axios';

export default class VisitasRepository{
    
    async getUploads(page,token){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
           
        const response = await axios.get(baseURL,{ headers: headers });
        return response;

    }

    async createUpload(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deleteUpload(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getUpload(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

}
</script>
